import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * RobotsApi - axios parameter creator
 * @export
 */
const RobotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Raw managed robots.txt, consumed by the storefront host. 404 when no managed file exists, so the storefront can fall back to its own static robots.txt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (options = {}) => {
            const localVarPath = `/v1/Robots/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Content for the admin editor. When nothing is managed yet, it is prefilled with the robots.txt currently served by the storefront (`isManaged = false`). (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContent: async (options = {}) => {
            const localVarPath = `/v1/Robots/GetContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {RobotsFileToken} [RobotsFileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (RobotsFileToken, options = {}) => {
            const localVarPath = `/v1/Robots/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RobotsFileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RobotsApi - functional programming interface
 * @export
 */
const RobotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RobotsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Raw managed robots.txt, consumed by the storefront host. 404 when no managed file exists, so the storefront can fall back to its own static robots.txt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobotsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Content for the admin editor. When nothing is managed yet, it is prefilled with the robots.txt currently served by the storefront (`isManaged = false`). (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContent(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContent(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobotsApi.getContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {RobotsFileToken} [RobotsFileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(RobotsFileToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(RobotsFileToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobotsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RobotsApi - factory interface
 * @export
 */
const RobotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RobotsApiFp(configuration);
    return {
        /**
         *
         * @summary Raw managed robots.txt, consumed by the storefront host. 404 when no managed file exists, so the storefront can fall back to its own static robots.txt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options) {
            return localVarFp.get(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Content for the admin editor. When nothing is managed yet, it is prefilled with the robots.txt currently served by the storefront (`isManaged = false`). (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContent(options) {
            return localVarFp.getContent(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {RobotsFileToken} [RobotsFileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(RobotsFileToken, options) {
            return localVarFp.update(RobotsFileToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RobotsApi - object-oriented interface
 * @export
 * @class RobotsApi
 * @extends {BaseAPI}
 */
class RobotsApi extends BaseAPI {
    /**
     *
     * @summary Raw managed robots.txt, consumed by the storefront host. 404 when no managed file exists, so the storefront can fall back to its own static robots.txt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobotsApi
     */
    get(options) {
        return RobotsApiFp(this.configuration).get(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Content for the admin editor. When nothing is managed yet, it is prefilled with the robots.txt currently served by the storefront (`isManaged = false`). (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobotsApi
     */
    getContent(options) {
        return RobotsApiFp(this.configuration).getContent(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {RobotsFileToken} [RobotsFileToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobotsApi
     */
    update(RobotsFileToken, options) {
        return RobotsApiFp(this.configuration).update(RobotsFileToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { RobotsApi, RobotsApiAxiosParamCreator, RobotsApiFactory, RobotsApiFp };
//# sourceMappingURL=robots-api.js.map
